import { sortDevices } from '@/js/utils';

const deviceData = (state) => state.deviceData;
const sortedDevices = (state) => (sortCriteria) =>
  Array.isArray(state.deviceData)
    ? state.deviceData.slice().sort((a, b) => sortDevices(a, b, sortCriteria))
    : null;
const numOfDevices = (state) => (state.deviceData || []).length;

export default {
  deviceData,
  sortedDevices,
  numOfDevices,
};
